import Vue from 'vue'
import AppLimitsAPI from '@/api/creative-studio/app_limits'

const limitsModel = {
  max_templates: 0,
  max_folders: 0,
  max_creatives: 0,
  max_disk_usage: 0,
  automation: false,
  animations: false,
  stock_assets: false,
}

const usageModel = {
  assets: 0,
  creatives: 0,
  folders: 0,
  templates: 0,
}

export const state = {
  templates: {
    modal: {
      templatesCategories: false,
      newCustomSizeTemplate: false,
      manageTemplate: false,
      duplicateTemplate: false,
      templateInfo: false,
      newTemplate: false,
    },
    selectedTemplate: null,
  },

  analytics: {
    globalPeriod: null,
  },

  assets: {
    modalAssetUpload: false,
    modalAssetManage: false,
    selectedAsset: {},
    mimeTypes: {},
    bulkSelectedAssetsById: [],

    uploadLimits: {
      // inclusive limits
      size: {
        // in bytes
        image: 2048 * 1024, // 2MB      => 2048KB
        shape: 200 * 1024, // 200KB    => 200KB
        audio: 5120 * 1024, // 5MB      => 5120KB
      },

      audioDuration: [2, 300000], // in ms, max 5 min
      imageSize: [10, 2560], // in px, width/height limits

      messages: {
        image: 'jpg/jpeg/png, max 2MB, min 10x10, max 2560x2560, max 1 file',
        shape: 'svg, max 200KB, max 1 file',
        audio: 'mp3, max. 10MB, max 1 file',
      },
    },
  },

  folders: {
    modalCreateRenameFolder: false,
    modalCreativeDetails: false,
    modalCreativesMove: false,
    renamedFolder: null,
    selectedCreative: null,
    bulkSelectedCreativesById: {
      finished: [],
      other: [],
    },
  },

  appLimits: { ...limitsModel },
  appUsage: { ...usageModel },

  limitsLoaded: false,
  isUsageLoading: false,
}

export const actions = {
  async loadAppLimits({ commit, state }) {
    state.limitsLoaded = false
    state.isUsageLoading = true

    try {
      const { data } = await AppLimitsAPI.getLimits()

      commit('setAppLimits', data.quota)
      commit('setAppUsage', data.usage)
    } catch (e) {
      console.warn(e.message)
    }
  },

  async loadAppUsage({ commit, state }, metrics) {
    state.isUsageLoading = true

    try {
      const { data } = await AppLimitsAPI.getUsage(metrics)

      commit('setAppUsage', data)
    } catch (e) {
      console.warn(e.message)
    }
  },
}

export const mutations = {
  RESET(state) {
    state.appLimits = { ...limitsModel }
    state.appUsage = { ...usageModel }
    state.limitsLoaded = false
    state.isUsageLoading = false
  },

  loadMimeTypes(state, payload) {
    state.assets.mimeTypes = payload
  },

  loadAnalyticsGlobalDate(state, payload) {
    state.analytics.globalPeriod = payload
  },

  toggleBulkSelectCreative(state, payload) {
    const isInList = state.folders.bulkSelectedCreativesById[payload.status].includes(payload.id)

    // add
    if (!isInList && payload.value === true) state.folders.bulkSelectedCreativesById[payload.status].push(payload.id)

    // remove
    if (isInList && payload.value === false) {
      const index = state.folders.bulkSelectedCreativesById[payload.status].indexOf(payload.id)
      Vue.delete(state.folders.bulkSelectedCreativesById[payload.status], index)
    }
  },

  toggleBulkSelectAsset(state, payload) {
    const isInList = state.assets.bulkSelectedAssetsById.includes(payload.id)

    // add
    if (!isInList && payload.value === true) state.assets.bulkSelectedAssetsById.push(payload.id)

    // remove
    if (isInList && payload.value === false) {
      const index = state.assets.bulkSelectedAssetsById.indexOf(payload.id)
      Vue.delete(state.assets.bulkSelectedAssetsById, index)
    }
  },

  setAppLimits(state, payload) {
    state.appLimits.max_templates = payload.max_templates || 0
    state.appLimits.max_folders = payload.max_folders || 0
    state.appLimits.max_creatives = payload.max_creatives || 0
    state.appLimits.max_disk_usage = payload.max_disk_usage || 0
    state.appLimits.automation = payload.automation || false
    state.appLimits.animations = payload.animations || false
    state.appLimits.stock_assets = payload.stock_assets || false

    state.limitsLoaded = true
  },

  setAppUsage(state, payload) {
    state.appUsage.assets = payload.assets || 0
    state.appUsage.creatives = payload.creatives || 0
    state.appUsage.folders = payload.folders || 0
    state.appUsage.templates = payload.templates || 0

    state.isUsageLoading = false
  },
}
